var QGIV = QGIV || {};

QGIV.Analytics = {
    /**
     * Google Analytics
     * https://developers.google.com/analytics/devguides/collection/analyticsjs/
     */
    GA : {        
        /**
         * Method to safely track events in Google Analytics
         * @param  {object} params Object containing data to send to Google Analytics. 'hitType' is a required parameter of the object, see GA documentation for possible values.
         */
        send : function(params){
            var params = params || {};
            if ( typeof ga !== 'undefined' ){
                ga('QgivAnalytics.send', params);
            }
        },

        /**
         * Method to safely set dimensions in Google Analytics
         * @param  {object} params Object containing data to send to Google Analytics. 'hitType' is a required parameter of the object, see GA documentation for possible values.
         */
        set : function(dimension, value){
            if ( typeof ga !== 'undefined' ){
                ga('QgivAnalytics.set', dimension, value);
            }
        }
    },

    /**
     * Intercom
     * http://docs.intercom.io/
     */
    Intercom : {
        /**
         * Method to safely track events in Intercom
         * @param  {string} name     Name of the event to track, in the past tense. Ex: 'Created Report'
         * @param  {object} metadata (Optional) Meta data to attach to the event
         */
        trackEvent : function(name, metadata){
            // make sure Intercom exists and we at least have a name
            if ( typeof Intercom !== 'undefined' && typeof name !== 'undefined' && name.length > 0 ){
                // if the metadata is defined, let's pass it to Intercom
                if ( typeof metadata !== 'undefined' && metadata instanceof Object ){
                    Intercom('trackEvent', name, metadata);
                } 
                // if not, let's just track the event
                else {
                    Intercom('trackEvent', name);
                }
            }
        }
    },

    /**
     * Segment
     * https://segment.com/docs/
     */
    Segment : {
        /**
         * Method to safely track events in Segment
         * @param  {string} name     Name of the event to track, in the past tense. Ex: 'Created Report'
         * @param  {object} [metadata] (Optional) Meta data to attach to the event
         * @param  {object} [options] (Optional) Options to attach to the event
         */
        track : function(name, metadata, options){
            // make sure Segement JS exists and we at least have a name
            if ( typeof analytics !== 'undefined' && typeof name !== 'undefined' && name.length > 0 ){
                // if metadata or options are defined, let's pass it to Segment
                if ( typeof metadata !== 'undefined' || typeof options !== 'undefined' ){
                    var metadata = metadata || {};
                    var options = options || {};
                    analytics.track(name, metadata, options);
                } 
                // if not, let's just track the event
                else {
                    analytics.track(name);
                }
            }
        },
        /**
         * Method to safely track page views in Segment
         * @param  {string} name     Name of the page to track, in the past tense. Ex: 'Dashboard'
         * @param  {object} options (Optional) Page options to override
         */
        page : function(name, options){
            // make sure Segement JS exists and we at least have a name
            if ( typeof analytics !== 'undefined' ){
                // if the options are defined, let's pass it to Segment
                if ( typeof name !== 'undefined' && typeof options !== 'undefined' && options instanceof Object ){
                    analytics.page(name, options);
                } 
                // check for name override
                else if ( typeof name !== 'undefined' ) {
                    analytics.page(name);
                }
                // if nothing else, let's just track the page
                else {
                    analytics.page();
                }
            }
        },
    },

    /**
     * FB App Events
     * https://developers.facebook.com/docs/app-events/getting-started-app-events-web
     */
    FB : {        
        /**
         * Method to safely log events with FB App Events
         * @param  {string} name     Name of the page to track, in the past tense. Ex: 'Dashboard'
         */
        logEvent : function(name){
            // make sure Intercom exists and we at least have a name
            if ( typeof FB !== 'undefined' && typeof name !== 'undefined' && name.length > 0 ){
                FB.AppEvents.logEvent(name);
            }
        }
    },
};